<template>
  <div>
    <!-- Page de connexion en dehors d'InitialLoading -->
    <router-view v-if="isLoginPage" />
    
    <!-- Autres pages avec InitialLoading -->
    <InitialLoading v-else>
      <router-view />
    </InitialLoading>

    <!-- Modal d'attribution global -->
    <AttributionModal />
    
    <!-- Viewer de caméra global -->
    <CameraViewer />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import InitialLoading from './components/InitialLoading.vue'
import AttributionModal from './components/Attribution/AttributionModal.vue'
import CameraViewer from './components/CameraViewer.vue'

export default {
  name: 'App',
  components: {
    InitialLoading,
    AttributionModal,
    CameraViewer
  },
  computed: {
    isLoginPage() {
      return this.$route.name === 'connexion'
    }
  },
  created() {
    // Équivalent du Provider et de l'initialisation du store
    this.initializeApp()
  },
  methods: {
    ...mapActions(['initializeApp'])
  }
}
</script>

<style lang="scss">
// Les styles globaux seront importés dans main.js
</style>
